export const SUMMARY_NEW_EMAIL_REQUEST = "SUMMARY_NEW_EMAIL_REQUEST";
export const SUMMARY_NEW_EMAIL_RECEIVE = "SUMMARY_NEW_EMAIL_RECEIVE";
export const SUMMARY_NEW_EMAIL_FAILURE = "SUMMARY_NEW_EMAIL_FAILURE";
export const RESET_SUMMARY_NEW_EMAIL = "RESET_SUMMARY_NEW_EMAIL";
